import Vue from "vue";
import VueRouter from "vue-router";
import {
  IntroView,
  LoginView,
  LoginQrcodeView,
  LoginSuccessView,
  LoginFailView,
  HomeView,
  LeagueView,
  ProgramView,
  ProgramDetailView,
  ThemeDetailView,
  SettingView,
  League2depthView,
  GameDetailView,
  AccountView,
  NoticeView,
  TermsView,
  ExitView,
  LogoutView,
  AvPlayerView,
  SessionExpireView,
  SignUpQrView,
  SubscriptionQrView,
  NoSubscriptionView,
  NetworkErrorView,
  ResponseErrorView,
  DeepLinkView,
  SamsungUpdateView,
  BitmovinPlayerView,
  CheckPermission,
  ChangeVoucher,
  SubscriptionExpiry,
} from "../views";
import GNBMenu from "../components/menu/GNBMenu.vue";
import LeagueMenu from "../components/menu/LeagueMenu.vue";
import GameDetailMenu from "../components/menu/GameDetailMenu.vue";
import ProgramDetailMenu from "../components/menu/ProgramDetailMenu.vue";
import ThemeDetailMenu from "../components/menu/ThemeDetailMenu.vue";

import { subInScope } from "@/utils/common";

Vue.use(VueRouter);

export default new VueRouter({
  // mode: 'history',
  routes: [
    // default
    {
      path: "/",
      redirect: "/intro/" + new Date().getTime(),
    },
    // 인트로
    {
      path: "/intro/:t",
      name: "intro",
      component: IntroView,
      props: true,
    },
    // 인트로 - 로그인 안내
    {
      path: "/login/:t",
      name: "login",
      component: LoginView,
      props: true,
    },
    // QR 로그인
    {
      path: "/login/qr/:t",
      name: "login-qr",
      component: LoginQrcodeView,
      props: true,
    },
    // 로그인 성공
    {
      path: "/login/success/:t",
      name: "login-success",
      component: LoginSuccessView,
      props: true,
    },
    // 로그인 실패
    {
      path: "/login/fail/:t",
      name: "login-fail",
      component: LoginFailView,
      props: true,
    },
    // 홈
    {
      path: "/home/:t",
      name: "home",
      components: {
        default: HomeView,
        leftSide: GNBMenu,
      },
      props: {
        leftSide: { gnbFocus: 1 },
      },
    },
    // 리그
    {
      path: "/league/:t",
      name: "league",
      components: {
        default: LeagueView,
        leftSide: GNBMenu,
      },
      props: {
        leftSide: { gnbFocus: 2 },
      },
    },
    // 프로그램
    {
      path: "/program/:t",
      name: "program",
      components: {
        default: ProgramView,
        leftSide: GNBMenu,
      },
      props: {
        leftSide: { gnbFocus: 3 },
      },
    },
    // 설정
    {
      path: "/setting/:t",
      name: "setting",
      components: {
        default: SettingView,
        leftSide: GNBMenu,
      },
      props: {
        leftSide: { gnbFocus: 4 },
      },
    },
    // 리그 세컨뎁스 목록
    {
      path: "/league/:gameTypeId/:leagueId/:t",
      name: "league2nd",
      components: {
        default: League2depthView,
        leftSide: LeagueMenu,
      },
      props: true,
    },

    // 리그 세컨뎁스 목록
    {
      path: "/league/year/:gameTypeId/:leagueId/:year/:t",
      name: "league2nd-year",
      components: {
        default: League2depthView,
        leftSide: LeagueMenu,
      },
      props: true,
    },

    // 리그 세컨뎁스 Seson별 목록
    {
      path: "/league/season/:gameTypeId/:leagueId/:seasonId/:t",
      name: "league2nd-season",
      components: {
        default: League2depthView,
        leftSide: LeagueMenu,
      },
      props: true,
    },
    // 게임 상세
    {
      props: true,
      path: "/game/:gameId/:t",
      name: "game-detail",
      components: {
        default: GameDetailView,
        leftSide: GameDetailMenu,
      },
    },
    // 리그 상세
    {
      props: true,
      path: "/league/:roundId/:t",
      name: "league-detail",
      components: {
        default: GameDetailView,
        leftSide: GameDetailMenu,
      },
    },
    // 프로그램 상세
    {
      props: true,
      path: "/program/:programId/:t",
      name: "program-detail",
      components: {
        default: ProgramDetailView,
        leftSide: ProgramDetailMenu,
      },
    },
    // VOD 리스트 상세
    {
      props: true,
      path: "/theme/:themeId/:t",
      name: "theme-detail",
      components: {
        default: ThemeDetailView,
        leftSide: ThemeDetailMenu,
      },
    },

    // 계정정보
    {
      path: "/setting/account/:t",
      name: "account",
      components: {
        default: AccountView,
        leftSide: GNBMenu,
      },
      props: {
        leftSide: { gnbFocus: 4 },
      },
    },
    // 개인정보 취급방침 약관
    {
      path: "/setting/terms/:t",
      name: "terms",
      components: {
        default: TermsView,
        leftSide: GNBMenu,
      },
      props: {
        leftSide: { gnbFocus: 4 },
      },
    },
    // 공지사항
    {
      path: "/notice/:t",
      name: "notice",
      component: NoticeView,
      props: true,
    },
    // 종료
    {
      path: "/exit/:t",
      name: "exit",
      component: ExitView,
      props: true,
    },
    // 로그아웃
    {
      path: "/logout/:t",
      name: "logout",
      component: LogoutView,
      props: true,
    },
    {
      props: true,
      path: "/player",
      name: "player",
      component: BitmovinPlayerView,
      beforeEnter: (to, from, next) => {
        subInScope(to.params.contentType, next);
      },
    },
    {
      props: true,
      path: "/avplayer",
      name: "avplayer",
      component: AvPlayerView,
      beforeEnter: (to, from, next) => {
        subInScope(next);
      },
    },

    {
      path: "/expire/:t",
      name: "expire",
      component: SessionExpireView,
      props: true,
    },
    {
      path: "/signup/:t",
      name: "signup",
      component: SignUpQrView,
      props: true,
    },
    {
      path: "/subscr/:t",
      name: "subscr",
      component: SubscriptionQrView,
      props: true,
    },
    {
      path: "/nosubscr/:t",
      name: "nosubscr",
      component: NoSubscriptionView,
      props: true,
    },
    {
      path: "/expiry/:t",
      name: "expiry",
      component: SubscriptionExpiry,
      props: true,
    },
    {
      path: "/err/net",
      name: "err-net",
      component: NetworkErrorView,
      props: true,
    },
    {
      path: "/err/api",
      name: "err-api",
      component: ResponseErrorView,
      props: true,
    },
    {
      path: "/samsungUpdate",
      name: "samsungUpdate",
      component: SamsungUpdateView,
      props: true,
    },
    // LG DeepLink 처리 페이지
    {
      path: "/deeplink/:data",
      name: "DeepLinkView",
      component: DeepLinkView,
      props: true,
    },
    {
      path: "/check/permission",
      name: "checkPermission",
      component: CheckPermission,
      props: true,
    },
    {
      path: "/voucher/change",
      name: "changeVoucher",
      component: ChangeVoucher,
      props: true,
    },
  ],
});
